'use strict';
const angular = require('angular');

export class importantNumberEditComponent {
  constructor(Config) {
    'ngInject';

    var directoriesConfig = Config.getModuleConfig(Config.Modules.Directories);

    this.categories = directoriesConfig.getImportantNumberCategories();
    this.categoryImage = directoriesConfig.getImportantNumberCategoryIcons();
  }

  $onInit() {
    this.importantNumber = this.resolve.importantNumber;
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  ok() {
    this.close({$value: this.importantNumber});
  }
}

export default angular.module('conduuApp.importantNumberEdit', [])
  .component('importantNumberEdit', {
    template: require('./important-number-edit.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: importantNumberEditComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/important-numbers/edit/important-number-edit.component.js